import React from 'react';
import { View, Pressable, Text, Switch, ViewStyle, TextStyle } from 'react-native';
import {ToolbarProps} from 'react-big-calendar';
import { VacancesType } from '../../../../api/Absence/types';
import { EventType } from '../../../../api/DemandeAbsence/types';
import { switchStyle, stdCouleurGris, stdCouleurBleuClair, stdCouleurBleu } from '@commonStyle';
import styles from '../../CalendrierUniversel.styles';

type Props = {
  vacances: VacancesType[],
  toggleVacances: (label: string) => void,
  buttonStyle: ViewStyle,
  textStyle?: TextStyle,
}
export default function FragmentToolbarVacances(props: ToolbarProps<EventType> & Props) {
  const {vacances, toggleVacances, buttonStyle, textStyle} = props;
  const width = `${100/3}%`;
  return(
    <View style={styles.vacancesContainer}>
      {vacances.length > 0 && (
        vacances.length === 1
        ? (
          <Switch
            value={vacances[0].selected}
            onValueChange={() => toggleVacances(vacances[0].label)}
            style={switchStyle}
            trackColor={{ false: stdCouleurGris, true: stdCouleurBleuClair }}
            thumbColor={stdCouleurBleu}
            ios_backgroundColor={stdCouleurGris}
           />
        )
        : (
          <View style={[styles.buttonList, styles.flex]}>
            {vacances.map((vacance) => {
              const selectedStyle : TextStyle = vacance.selected
                ? {
                    color: vacance.couleur,
                    textDecorationLine: 'underline',
                    textDecorationColor: vacance.couleur
                  }
                : {};
              return(
                <Pressable
                  key={vacance.label}
                  onPress={() => toggleVacances(vacance.label)}
                  style={{...buttonStyle, width}}
                  testID={`BT_VACANCES_${vacance.label.replace('Zone ', '').toUpperCase().replaceAll(' ', '_')}`}
                >
                  <Text style={{...textStyle, ...selectedStyle}}>{vacance.label.replace('Zone ', '')}</Text>
                </Pressable>
              )
            })}
          </View>
        )
      )}
    </View>
  )
}
